import { ButtonElement } from "@redotech/redo-model/content-builder/element-schema";
import { memo } from "react";
import { BrandKitButton } from "../../brand-kit-button";
import { FormElementProps } from "./index";

export const FormButton = memo(function FormButton({
  element,
  brandKit,
  brandKitOverrides,
  submitting,
  onClose,
}: Pick<
  FormElementProps<ButtonElement>,
  "element" | "brandKit" | "brandKitOverrides" | "onClose" | "submitting"
>) {
  if (element.action === "close" && !onClose) {
    return null;
  }

  return (
    <BrandKitButton
      brandKit={brandKit}
      hierarchy={element.hierarchy}
      onClick={() => {
        if (onClose && element.action === "close") {
          onClose();
        }
      }}
      override={
        brandKitOverrides.buttons.enabled
          ? brandKitOverrides.buttons
          : undefined
      }
      pending={submitting}
      text={element.text}
      type={element.action === "submit-and-advance" ? "submit" : "button"}
    />
  );
});
